import LoggedUserMenu from './LoggedUserMenu'

export default LoggedUserMenu
